import { AnalyticsActions } from '../constants'


export const screenTracking = ({ getState }) => next => (action) => {
  const exclude_paths = ['/oauthcallback']

  if (action.type !== '@@router/LOCATION_CHANGE' || getState().router.location === null || exclude_paths.indexOf(getState().router.location.pathname) > -1) {
    return next(action);
  }

  const before = getState().router.location.pathname
  const result = next(action);
  const after = getState().router.location.pathname

  if (before !== after) {
    var nav_action = AnalyticsActions[after]

    if (!action) {
      nav_action = 'UNKNOWN'
      return result;
    }

    // Need to check for the maintenance flag
    const state = getState()
    const employee_id = state.employee.id
    if (state.maintenance.status !== "MAINT" &&
        employee_id !== undefined &&
        state.auth &&
        state.auth.auth &&
        state.auth.auth.secret &&
        nav_action) {
      const myRequest = new Request(`${process.env.REACT_APP_API_GATEWAY}/analytics/employees/${employee_id}/action/${nav_action}`)

      /* global digitalData */
      digitalData.page = nav_action
      document.body.dispatchEvent(new Event('page_changed'));

      fetch(myRequest, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'content-type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${state.auth.auth.secret}`
        }
      })
      .then(response => {})
      .catch(error => {})
    }
  }

  return result
}